import {Component} from "react";
import React from "react";
import './style.scss';
import FacebookLogin from 'react-facebook-login';
import AppleLogin from 'react-apple-login';
import GoogleLogin from 'react-google-login';
import * as config from '../../../../const/config/config'


class App extends Component {


  componentWillMount() {

  }

  responseFacebook = (response) => {
    if (response !== null && response.accessToken !== undefined) {
      let obj = {
        firstName:response.name.split(' ')[0] ? response.name.split(' ')[0] : '',
        lastName:response.name.split(' ')[1] ? response.name.split(' ')[1] : '',
        email: response.email ? response.email : '',
        socialMediaToken:response.accessToken,
        userSocialId:response.userID,
        authType:'FACEBOOK'
      }
      this.props.setData(obj)
    }
  }

  responseGoogle = (response) => {
    if (response.profileObj !== undefined){
      let obj = {
        firstName:response.profileObj.givenName,
        lastName:response.profileObj.familyName,
        email:response.profileObj.email ? response.profileObj.email : '',
        socialMediaToken:response.tokenId,
        userSocialId:response.profileObj.googleId,
        authType:'GOOGLE'
      }
      this.props.setData(obj)
    }
    this.props.callback({
      type: "GMAIL",
      payload: response
    })
  }


  render() {
    let {isHideApple} = this.props;
    return (
      <div className={'social-media-btn-div'}>
        <p className={'or-section'}>Or</p>
        {!isHideApple ? <AppleLogin
          clientId={config.APPLE_SIGN_UP_ID}
          redirectURI={config.APPLE_SIGN_UP_REDIRECT_URI}
          responseType={"code"}
          responseMode={"query"}
          usePopup={false}
          /*designProp={
            {
              color: "black",
              border: false,
              type: "sign-up",
              border_radius: 15,
              scale: 1,
              locale: "en_US",
            }
          }*/
          render={(renderProps) => (
            <button id={'appleId-btn'} onClick={renderProps.onClick}>
              <i className="fa fa-apple" style={{marginRight:'5px'}}></i>
              {this.props.type === 'sign-up' ? 'Sign up with Apple' : 'Sign in with Apple'}
            </button>
          )}
          onSuccess={(response) => console.log('responseApple - success', response)}
          onError={(response) => console.log('responseApple - error', response)}
        />:null}
        <GoogleLogin
          clientId={config.GOOGLE_SIGN_UP_ID}
          render={(renderProps) => (
            <button id={'google-btn'} onClick={renderProps.onClick}>
              <i className="fa fa-google" style={{marginRight:'5px'}}></i>
              {this.props.type === 'sign-up' ? 'Sign up with Google' : 'Sign in with Google'}
            </button>
          )}
          onSuccess={this.responseGoogle}
          onFailure={this.responseGoogle}
          cookiePolicy={"single_host_origin"}
          className="GOOGLE"
        />
        <FacebookLogin
          appId={config.FACEBOOK_SIGN_UP_ID}
          autoLoad={false}
          fields="name,email"
          scope="public_profile"
          callback={this.responseFacebook}
          icon={<i className="fa fa-facebook" style={{marginRight:'6px'}}>
          </i>}
          textButton={this.props.type === 'sign-up' ? "Sign up with Facebook" : "Sign in with Facebook"}
        />
      </div>
    );
  }
}

export default App
